import {Component} from '@angular/core';
/**
 * \@title Basic progress-spinner
 */
export class ProgressSpinnerOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'progress-spinner-overview-example',
  templateUrl: 'progress-spinner-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ProgressSpinnerOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
ProgressSpinnerOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProgressSpinnerOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
